import { callGetApiWithAuth } from "./api";
import { getUser, saveStorage } from "./auth";

const getMeCallApiWithAuthOnly = () => {
    callGetApiWithAuth('/auth/me', (me) => {
        let user = getUser();
        me.accessToken = user.accessToken;
        saveStorage(me);
    }, (err) => {
        console.log(err);
    });
}

export { getMeCallApiWithAuthOnly };